import { useState } from 'react';
import axios from 'axios';

const YOUTUBE_API_KEY = process.env.REACT_APP_YOUTUBE_API_KEY;
const YOUTUBE_SEARCH_URL = 'https://www.googleapis.com/youtube/v3/search';

const useYouTubeSearch = () => {
  const [videos, setVideos] = useState<{ title: string; url: string; thumbnail: string }[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const searchYouTube = async (query: string) => {
    if (!query.trim()) return;
    if (!YOUTUBE_API_KEY) {
      setError('YouTube API Key is missing.');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await axios.get(YOUTUBE_SEARCH_URL, {
        params: {
          key: YOUTUBE_API_KEY,
          part: 'snippet',
          type: 'video',
          q: query,
          maxResults: 4,
        },
      });

      // Map the response to extract title, URL, and thumbnail
      const results: { title: string; url: string; thumbnail: string }[] = response.data.items.map(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (item: any) => ({
          title: item.snippet.title,
          url: `https://www.youtube.com/watch?v=${item.id.videoId}`,
          thumbnail: item.snippet.thumbnails.medium.url, // ✅ Add thumbnail
        }),
      );

      setVideos(results);
    } catch (err) {
      setError('Failed to fetch videos');
    } finally {
      setLoading(false);
    }
  };

  const clearSearch = () => {
    setVideos([]);
    setLoading(false);
    setError(null);
  };

  return { videos, loading, error, searchYouTube, clearSearch };
};

export default useYouTubeSearch;
